import { render, staticRenderFns } from "./KeyTwelve.vue?vue&type=template&id=5008a71e&scoped=true&"
import script from "./KeyTwelve.vue?vue&type=script&lang=js&"
export * from "./KeyTwelve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008a71e",
  null
  
)

export default component.exports